"use client";
import React from "react";
import { PropertyTypeKey } from "../../../constants/mockProperties";
import Button from "../../../ui/Button";

interface TabsProps {
  activeTab: PropertyTypeKey;
  onTabChange: (key: PropertyTypeKey) => void;
}

const tabsData: { key: PropertyTypeKey; name: string }[] = [
  { key: "forRent", name: "Rent" },
  { key: "forSale", name: "Sales" },
  { key: "forShortlet", name: "Short Let" },
];

const Tabs: React.FC<TabsProps> = ({ activeTab, onTabChange }) => {
  const isDemoMode = process.env.NEXT_PUBLIC_DEMO_MODE === "true"; // Check if DEMO_MODE is true

  return (
    <div className="tabs hero-item wrapper flex gap-4 mt-[3rem] z-[10] relative">
      {tabsData.map((item) => (
        <Button
          key={item.key}
          className={`tab-button !px-0 xs:!grid xs:place-items-center max-w-[110px] w-[30%]  ${
            activeTab === item.key
              ? "bg-white border-white !text-themeColor"
              : "bg-transparent border border-white"
          }`}
          onClick={() =>
            isDemoMode || item.key === "forRent"
              ? onTabChange(item.key)
              : undefined
          } // Disable click if in DEMO_MODE and not Rent
          disabled={!isDemoMode && item.key !== "forRent"} // Disable button in DEMO_MODE for anything other than Rent
        >
          <span className="whitespace-nowrap">{item.name}</span>
        </Button>
      ))}
    </div>
  );
};

export default Tabs;
